import { Link } from "react-router-dom";
import Slider from "react-slick";
import { useRef, useState, useEffect } from "react";
import Countdown from "./Countdown";


const NewItems = ({ items, loadingState, settings }) => {
  let sliderRef = useRef(null);
  return (
    <section id="section-items" className="no-bottom">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="text-center">
              <h2>New Items</h2>
              <div className="small-border bg-color-2"></div>
            </div>
          </div>
          <Slider ref={slider => { sliderRef = slider }} {...settings} >
            {loadingState ?
              (new Array(4).fill(0).map((_, index) => (
                <div
                  key={index}
                  data-aos="fade-up"
                  className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12"
                  style={{ display: "block", backgroundSize: "cover" }}
                >
                  <div className="nft__item">
                    <div className="author_list_pp">
                      <div className="skeleton-box lazy" style={{ width: "50px", height: "50px", borderRadius: "50%" }}>
                      </div>
                      <i className="fa fa-check"></i>
                    </div>
                    <div className="de_countdown">0h 0m 0s</div>

                    <div className="nft__item_wrap">
                      <div className="skeleton-box" style={{ width: "100%", height: "200px" }} />
                    </div>
                    <div className="nft__item_info">
                      <div className="skeleton-box"
                        style={{ width: "100px", height: "20px", borderRadius: "5px" }}>
                      </div>
                      <br />
                      <div className="skeleton-box"
                        style={{ width: "60px", height: "20px", borderRadius: "5px", marginRight: "65%" }}>
                      </div>
                      <div className="nft__item_like">
                        <i className="fa fa-heart"></i>
                        <span>0</span>
                      </div>
                    </div>
                  </div>
                </div>
              )))
              :
              (items.map(({ id, authorId, authorImage, nftImage, nftId, title, price, likes, expiryDate }) => {
                return (
                  <div className="nft__item" key={id} data-aos="fade-up">
                    <div className="author_list_pp">
                      <Link
                        to={`/author/${authorId}`}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Creator: Monica Lucas"
                      >
                        <img className="lazy" src={authorImage} alt={`Profile picture for user ${authorId}`} />
                        <i className="fa fa-check"></i>
                      </Link>
                    </div>
                    {expiryDate != null ? <Countdown expiryDate={expiryDate} /> : null}
                    <div className="nft__item_wrap">
                      <div className="nft__item_extra">
                        <div className="nft__item_buttons">
                          <button>Buy Now</button>
                          <div className="nft__item_share">
                            <h4>Share</h4>
                            <a href="" target="_blank" rel="noreferrer">
                              <i className="fa fa-facebook fa-lg"></i>
                            </a>
                            <a href="" target="_blank" rel="noreferrer">
                              <i className="fa fa-twitter fa-lg"></i>
                            </a>
                            <a href="">
                              <i className="fa fa-envelope fa-lg"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                      <Link to={`/item-details/${nftId}`}>
                        <img
                          src={nftImage}
                          className="lazy nft__item_preview"
                          alt={`Displays nft with id: ${nftId}`}
                        />
                      </Link>
                    </div>
                    <div className="nft__item_info">
                      <Link to={`/item-details/${nftId}`}>
                        <h4>{title}</h4>
                      </Link>
                      <div className="nft__item_price">{price} ETH</div>
                      <div className="nft__item_like">
                        <i className="fa fa-heart"></i>
                        <span>{likes}</span>
                      </div>
                    </div>
                  </div>
                )
              }))
            }
          </Slider>

        </div>
      </div>
    </section>
  );
};

export default NewItems;


